import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { InflectionCurve } from "@/components/Curve";

const CAPABILITIES = [
  "Executive Coaching",
  "Executive Operations",
  "Large-Scale Transformation",
  "Organizational Change",
  "Portfolio Management",
  "AI Strategy",
  "Workforce & Staffing Strategy",
  "Executive Leadership",
];

export const Differentiator = () => (
  <section className="relative overflow-hidden" data-testid="differentiator-block">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
      <div className="grid gap-16 md:grid-cols-12">
        <div className="md:col-span-7">
          <Reveal>
            <blockquote className="font-serif text-3xl leading-snug text-white sm:text-4xl md:text-[2.75rem]">
              Most coaches only coach. Most consultants only advise. Most PM consultants
              only deliver projects.{" "}
              <span className="italic text-teal">QuInflection combines all of it.</span>
            </blockquote>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl font-sans text-base leading-relaxed text-white/60 md:text-lg">
              This isn't a bundle of services — it's one integrated capability, built for
              leaders who need more than a report. We stay in the work until the change sticks.
            </p>
          </Reveal>
          <InflectionCurve className="mt-10 w-56 opacity-80 md:w-72" />
        </div>

        <div className="md:col-span-5">
          <ul className="divide-y divide-white/10 border-y border-white/10">
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c} delay={i * 0.06} y={16}>
                <li
                  className="group flex items-center gap-4 py-4"
                  data-testid={`capability-${i}`}
                >
                  <span className="flex h-6 w-6 items-center justify-center rounded-full border border-teal/40 transition-colors duration-300 group-hover:bg-teal">
                    <Check className="h-3.5 w-3.5 text-teal transition-colors duration-300 group-hover:text-navy" />
                  </span>
                  <span className="font-sans text-base text-white/80 transition-transform duration-300 group-hover:translate-x-1">
                    {c}
                  </span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
